import React from "react";
import { useField } from "formik";

// components
import FormErrorMessage from "./FormErrorMessage";

import styles from "./input.module.css";

function FormInput({ ...otherProps }) {
  const [field, meta] = useField(otherProps);
  let className;

  if (meta.touched && meta.error) {
    className = "error";
  } else if (meta.touched && !meta.error) {
    className = "success";
  }

  return (
    <div className={styles.main}>
      <input
        type="text"
        className={`${styles.inputText}  ${styles[className]}`}
        required
        {...otherProps}
        {...field}
      />
      <FormErrorMessage name={field.name} />
    </div>
  );
}

export default FormInput;
